import type { NumberOfBaseplates } from "../model/project-primitives.ts";

function renderBaseplateOutlines(
	context2d: CanvasPath & CanvasDrawPath & CanvasFillStrokeStyles,
	numberOfBaseplates: NumberOfBaseplates,
	canvasWidth: number,
	canvasHeight: number,
) {
	/* eslint-disable-next-line no-param-reassign */
	context2d.strokeStyle = "#aaaaaa";
	context2d.beginPath();
	const plateWidth = (canvasWidth - 1) / numberOfBaseplates.width;
	for (let x = 0; x <= numberOfBaseplates.width; x++) {
		const lineX = Math.round(x * plateWidth) + 0.5;
		context2d.moveTo(lineX, 0);
		context2d.lineTo(lineX, canvasHeight);
	}
	const plateHeight = (canvasHeight - 1) / numberOfBaseplates.height;
	for (let y = 0; y <= numberOfBaseplates.height; y++) {
		const lineY = Math.round(y * plateHeight) + 0.5;
		context2d.moveTo(0, lineY);
		context2d.lineTo(canvasWidth, lineY);
	}
	context2d.stroke();
}

export default renderBaseplateOutlines;
